import styled from 'styled-components';

interface HideProps {
  when: boolean;
  maxWidth: string;
}
export const Hide = styled.div<HideProps>`
  ${props => {
    return (
      props.when &&
      `@media (max-width: ${props.maxWidth}) {
         display: none;
      }`
    );
  }};
`;
